import { connect } from 'react-redux';
import CAP from './CAP';

import {
    setCAPTerm,
    setShowCAP,
    setCAPDownPayment,
} from '../../common/cap/actions';


import { setCAPIsVisible } from './actions';

import { setSelectedFinancing } from '../../common/settings/actions';

const mapStateToProps = state => ({
    isLocked: state.isLockedUI.isLocked,
    isVisible: state.capUI.isVisible,
    capDownPayment: state.cap.capDownPayment,
    capTerm: state.cap.capTerm,
    showCAP: state.cap.showCAP,
    resiToggle: state.tax.resiToggle,
    setCAPIsVisible,
    setShowCAP,
    setCAPTerm,
    setCAPDownPayment,
    setSelectedFinancing,
});

const combinedActions = {
    setCAPIsVisible,
    setShowCAP,
    setSelectedFinancing,
    setCAPTerm,
    setCAPDownPayment,
};

export default connect(mapStateToProps, combinedActions)(CAP);



// WEBPACK FOOTER //
// ./src/containers/Inputs/CAP/index.js